/*
  LOULEX-Anpassung (#61): Farbwechsel auf der wischbaren Produktkarte (snippets/product-card.liquid).
  Ersetzt die weiteren Fotos durch die der neuen Farbe und springt auf das erste Bild. Das Hauptbild
  tauscht weiter Prestige (ProductCard in theme.js).
*/
(() => {
  const WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000];
  const withWidth = (src, width) => src.replace(/([?&])width=\d+/, `$1width=${width}`);

  document.addEventListener('change', (event) => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-variant-id')) {
      return;
    }

    const card = input.closest('product-card');
    const reel = card?.querySelector('.loulex-card-reel');
    const data = card?.querySelector('script[data-loulex-card-media]');

    if (!reel || !data) {
      return;
    }

    let slides;

    try {
      slides = JSON.parse(data.textContent)[input.getAttribute('data-variant-id')];
    } catch (error) {
      return;
    }

    if (!Array.isArray(slides)) {
      return;
    }

    reel.querySelectorAll('.loulex-card-slide').forEach((slide) => slide.remove());

    slides.forEach((media) => {
      const image = new Image(media.w, media.h);
      image.className = 'loulex-card-slide';
      image.loading = 'lazy';
      image.fetchPriority = 'low';
      image.draggable = false;
      image.alt = media.a || '';
      image.sizes = reel.getAttribute('data-loulex-sizes') || '50vw';
      image.srcset = WIDTHS.filter((width) => width <= media.w).map((width) => `${withWidth(media.s, width)} ${width}w`).join(', ');
      image.src = withWidth(media.s, 800);

      if (media.f) {
        image.style.objectPosition = media.f;
      }

      reel.append(image);
    });

    reel.scrollTo({ left: 0, behavior: 'instant' });
  });
})();
